import OpenCloseRoom from './OpenCloseRoom.container';

export default OpenCloseRoom;
